<!-- HISTORY: has this.log(msg)
   V250416.1: Added associationType prop and passed it to iframe.
   V250414.1: Fixed the bug that didn't send message properly in the edit mode.
   V250411.1: 1st version/release.
-->
<template>
   <div>
      <v-tooltip left>
         <template v-slot:activator="{ on }">
            <v-btn text icon
               v-on="on"
               @click="btnClicked"
            >
               <v-icon>{{btnIconName}}</v-icon>
            </v-btn>
         </template>
         <span>{{btnTooltip}}</span>
      </v-tooltip>

      <v-dialog no-click-animation persistent scrollable
         max-width="1080px"
         v-model="dialog"
      >
         <v-card flat :loading="!iframeLoaded">
            <v-card-title class="title grey--text darken-4 font-weight-bold">Instruction for {{appName}}
               <div class="flex-grow-1"></div>
            </v-card-title>

            <v-card-text>
               <iframe
                  ref="iframeRef"
                  frameborder="0"
                  width="100%"
                  height="500"
                  @load="onIframeLoad"
                  :src="iframeUrl"
               ></iframe>
            </v-card-text>
         </v-card>
      </v-dialog>
   </div>
</template>

<script>
const NAME = "BtGenericApp703";
const VERSION = 'V250416.1';

function _isNonEmptyObject(obj) {
  return obj && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length > 0;
}

export default {
   name: NAME,

   props: {
      value: {
         type: Object,
         required: true,
         default: () => {}
      },
      appEndpoint: {
         type: String,
         required: true,
      },
      appName: {
         type: String,
         default: ""
      },
      associationType: {
         type: Array,
         required: true
      },
      btnIconName: {
         type: String,
         default: "more_vert"
      },
      btnTooltip: {
         type: String,
         default: "click to configure"
      },
      consumerCode: {
         type: String,
         required: true
      },
      debug: {
         type: Boolean,
         default: false
      },
      isActualEndpoint: {
         type: Boolean,
         default: true
      },
      iframeUrl: {
         type: String,
         required: true
      }
   },

   data() {
      return {
         dialog: false,
         messageHandled: false,
         iframeLoaded: false
      }
   },

   methods: {
      log(msg) {
         if (this.debug) {
            console.log(`-----${NAME} ${VERSION} says => ${msg}`);
         }
      },

      btnClicked() {
         // alert('in btnClicked(): this.value=' + JSON.stringify(this.value));
         window.addEventListener('message', this.handleMessage);
         this.dialog = true;
         if (this.iframeLoaded)
            setTimeout(() => {
               this.sendMessage();
            }, 10);
      },

      onIframeLoad() {
         setTimeout(() => {
            this.iframeLoaded = true;
            this.sendMessage();
         }, 10);
      },

      sendMessage() {
         if (this.$refs.iframeRef && this.$refs.iframeRef.contentWindow) {
            const postMsg = this.value.instruction ? this.value : { instruction: {} };
            postMsg.associationType = this.associationType;
            this.log('in sendMessage(): postMsg=' + JSON.stringify(postMsg));
            this.$refs.iframeRef.contentWindow.postMessage(postMsg, '*');
            this.messageHandled = false;
         }
      },

      handleMessage(event) {
         if (this.messagehandled) return;

         // alert('in handleMessage(): event=' + JSON.stringify(event.data));
         // // if (event.origin?.toLowerCase() !== window.location.origin.toLowerCase()) {
         // //    alert("Blocked message from untrusted origin: ", event.origin);
         // // } else

         if (event.data && "isCancelled" in event.data) {
            this.messageHandled = true;

            if (!event.data?.isCancelled && _isNonEmptyObject(event.data?.instruction)) {
               const result = { 
                  instruction: event.data.instruction,
                  consumerCode: this.consumerCode,
                  appEndpoint: this.appEndpoint
               };

               this.$emit('change', result);
               this.$emit('input', result);
            }

            window.removeEventListener('message', this.handleMessage);         
            this.dialog = false;
         }
      }
   },

   mounted() { },

   beforeDestroy() { }
}
</script>

<style scoped>
iframe {
   border: 1px solid #ccc;
   border-radius: 8px;
}
</style>
